import axios from "axios";
import * as Api from "../constants/Api";
import { loadStart, loadEnd, modalOpen, modalClose } from "./App";

export const modalCloseInAuth = () => {
  return dispatch => {
    dispatch(modalClose());
  };
};

export const sendContact = (enterpriseId, token, email, description, flag) => {
  return dispatch => {
    dispatch(loadStart);

    axios
      .post(
        Api.contactsApi,
        {
          code: "create",
          enterpriseId,
          email,
          description,
          contactFlag: flag
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        // eslint-disable-next-line no-param-reassign
        res = JSON.parse(res.data.body);
        if (res.data) {
          dispatch(modalOpen(res.data));
        } else if ("errorMessage" in res) {
          dispatch(modalOpen(res.errorMessage.errMsg, "送信エラー"));
        }
        dispatch(loadEnd());
      })
      .then(res => {
        // eslint-disable-next-line no-param-reassign
        res = JSON.parse(res.data.body);
        if (res.data) {
          dispatch(modalOpen(res.data));
        } else if ("errorMessage" in res) {
          dispatch(modalOpen(res.errorMessage.errMsg, "送信エラー"));
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd);
      });
  };
};
